import * as React from 'react';
import { DialogTitle } from '@material-ui/core';
import { DialogContent } from '@material-ui/core';
import { DialogActions } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { translation } from '../../i18n';
import { Dialog } from '@material-ui/core';
import { IObservableObject, IObservableValue, observable } from 'mobx';
import { observer } from 'mobx-react';
import { emptyQuestionCatalogue, QuestionCatalogueDto } from './qustionCatalogueTypes';
import QuestionModulePreview from '../../components/preview/QuestionModulePreview';

interface Props {
  onClose: () => void;
  catalogue: QuestionCatalogueDto & IObservableObject;
  open: boolean;
}

@observer
export default class QuestionCatalogueDialog extends React.Component<Props> {

  @observable private questionCatalogue: QuestionCatalogueDto & IObservableObject = observable(emptyQuestionCatalogue());
  private expanded: IObservableValue<string> = observable.box('');

  constructor(props: Props) {
    super(props);
    this.init = this.init.bind(this);
  }

  public render() {
    return (
      <Dialog
        id="QuestionnaireDialog"
        open={this.props.open}
        onClose={this.props.onClose}
        fullWidth={true}
        maxWidth="md"
        onRendered={this.init}
      >
        <DialogTitle id="form-dialog-title">{this.questionCatalogue.title}</DialogTitle>
        <DialogContent>
          {
            this.questionCatalogue.modules.map(module =>
              <QuestionModulePreview key={module.id} expanded={this.expanded}  module={module}/>
            )
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose} color="primary">
            {translation.t('actions.ok')}
          </Button>
        </DialogActions>

      </Dialog>)
  }

  private init() {
    this.questionCatalogue = this.props.catalogue;
  }
}
